<mat-expansion-panel class="box-shadow border-radius-0" #panel>
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">hotel</mat-icon>
      <span>Hotel</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <app-hotel-info [dutyPeriodIndex]="dutyPeriodIndex"></app-hotel-info>
  </ng-template>
</mat-expansion-panel>

